import { Cookies } from "react-cookie";

const baseUrl = process.env && process.env.BFF_URL ? process.env.BFF_URL : '';

const cookie: Cookies = new Cookies();

export const parseResponse = async (res: any) => {
    try {
    const result = await res.clone().json();
        return result;
    } catch (e) {
        return null;
    }
};

export const callApi = async (url: string, method: string, request?: any) => {
    try {              
        const response = await fetch(`${baseUrl}/${url}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + cookie.get('_ath')
             },
            cache: 'no-cache',
            body: request ? JSON.stringify(request) : null,
        }).then((response) => {
            return response.json();
        });
        return response;
    } catch (error) {
        if (cookie.get('_ath')) {
            console.error(error);
            throw new Error();
        } else {
            console.error(error);
            window.location.replace('/login');
            throw new Error();
        }
    }
}


export const downloadFile = async (base64: string, mimeType: string, name: string) => {
    const bytes = base64ToByteArray(base64);
    const blob = new Blob([bytes], { type: mimeType });
  
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(blob, name);
    } else {
      const downloadURL = URL.createObjectURL(blob);
      createDownload(downloadURL, name, 1000);
    }
  };

  export const createDownload = async (downloadURL: string, name: string, waitTime: number) => {
    const fileLink = document.createElement('a');
    document.body.appendChild(fileLink);
  
    fileLink.style.display = 'none';
    fileLink.href = downloadURL;
    fileLink.download = name;
    fileLink.click();
  
    await wait(waitTime);
    URL.revokeObjectURL(downloadURL);
    document.body.removeChild(fileLink);
  };

  export function base64ToByteArray(base64: string) {
    const binaryString = atob(base64);
    const binaryLength = binaryString.length;
    const buffer = new ArrayBuffer(binaryLength);
    const byteArray = new Uint8Array(buffer);
    for (let i = 0; i < binaryLength; i += 1) byteArray[i] = binaryString.charCodeAt(i);
  
    return byteArray;
  }

export const wait = (ms: number) => {
return new Promise(resolve => {
    setTimeout(() => {
    resolve(true);
    }, ms);
});
};